import { Config } from "../../views/settings/config/index";
import { System } from "../../views/settings/system";
import { Notice } from "../../views/settings/notice/index";
import { Email } from "../../views/settings/email/index";
import { Banner } from "../../views/settings/banner/index";

import { langPage } from "../../locales";

const lang = langPage?.settings;

export const settingsRouters = [
  {
    path: "/settings/notice",
    name: "notice",
    exact: true,
    component: Notice,
    meta: {
      breadcrumb: [
        {
          name: lang?.name,
          path: ""
        },
        {
          name: lang?.notice?.notice,
          path: ""
        }
      ],
      privilegeCode: "notice",
    }
  },
  {
    path: "/settings/config",
    name: "config",
    exact: true,
    component: Config,
    meta: {
      breadcrumb: [
        {
          name: lang?.name,
          path: ""
        },
        {
          name: lang?.config?.name,
          path: ""
        }
      ],
      privilegeCode: "config",
    }
  },
  {
    path: "/settings/system",
    name: "system",
    exact: true,
    component: System,
    meta: {
      breadcrumb: [
        {
          name: lang?.name,
          path: ""
        },
        {
          name: lang?.system?.name,
        }
      ],
      privilegeCode: "system",
    }
  },
  {
    path: "/settings/email",
    name: "email",
    exact: true,
    component: Email,
    meta: {
      breadcrumb: [
        {
          name: lang?.name,
          path: ""
        },
        {
          name: "邮箱配置",
        }
      ],
      privilegeCode: "email",
    }
  },
  {
    path: "/settings/banner",
    name: "banner",
    exact: true,
    component: Banner,
    meta: {
      breadcrumb: [
        {
          name: lang?.name,
          path: ""
        },
        {
          name: "轮播图配置",
        }
      ],
      privilegeCode: "banner",
    }
  },
];
